import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import type { Locale } from 'date-fns'
import { de, enGB, nl } from 'date-fns/locale'
import resources from './locales'

export const DEFAULT_LANGUAGE = 'en'
export const LANGUAGES = ['en', 'nl', 'de'] as const
export type Language = (typeof LANGUAGES)[number]
export type NonDefaultLanguage = Exclude<Language, typeof DEFAULT_LANGUAGE>

const isDev = import.meta.env.DEV

export const localeMap = {
  en: enGB,
  nl,
  de
} as const satisfies Record<Language, Locale>

export function getDateFnsLocale (language: Language): Locale {
  return localeMap[language]
}

void i18n.use(initReactI18next).init({
  showSupportNotice: false,
  debug: isDev,
  fallbackLng: 'en',
  supportedLngs: ['en', 'nl', 'de'],
  resources,
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: true
  }
})

export default i18n
